import { z } from 'zod'

export const schema = z.object({
  id: z.number(),
  attributes: z.object({
    publishedAt: z.string().nullable(),
    hero: z.object({
      author: z.string().min(1).nullable(),
      image: z.object({
        data: z.object({
          attributes: z.object({
            url: z.string().min(1),
          }),
        }),
      }),
    }),

    intro_seo_text: z.object({
      title: z.string().min(1),
      text: z.string().min(1),
    }),

    image_banner: z
      .object({
        title: z.string().min(1),
        text: z.string().min(1),
        button: z
          .object({
            text: z.string().min(1),
            url: z.string().min(1).nullable(),
          })
          .nullable(),
        image: z.object({
          data: z.object({
            attributes: z.object({
              url: z.string().min(1),
            }),
          }),
        }),
      })
      .nullable(),

    featured_destinations: z.array(
      z.object({
        title: z.string().min(1).nullable(),
        card: z.array(
          z.object({
            title: z.string().min(1),
            url: z.string().min(1),
            image: z.object({
              data: z.array(
                z.object({
                  attributes: z.object({
                    url: z.string().min(1),
                  }),
                }),
              ),
            }),
          }),
        ),
        button: z.object({
          text: z.string().min(1),
          url: z.string().min(1),
        }),
      }),
    ),
  }),
})

export type schemaType = z.infer<typeof schema>
